import type { GetPlanChangeOptions200DowngradeOptionsItem } from './getPlanChangeOptions200DowngradeOptionsItem';
import type { GetPlanChangeOptions200UpgradeOptionsItem } from './getPlanChangeOptions200UpgradeOptionsItem';

export type GetPlanChangeOptions200 = {
  downgradeOptions?: GetPlanChangeOptions200DowngradeOptionsItem[];
  upgradeOptions?: GetPlanChangeOptions200UpgradeOptionsItem[];
};
